export default __webpack_public_path__ + "static/media/SETTINGS.e1bb0eda.png";